<template>
    <div>
        <template v-if="loaded">
            <rkm-form
                ref="Form"
                :show-legend="!isSaved"
            >
                <rkm-area title="Dados">
                    <rkm-form ref="Form">
                        <rkm-row>
                            <rkm-col cols="6">
                                <rkm-form-select
                                    :disabled="isSaved || hasItens"
                                    :options="form.unidades"
                                    :validations="validations.unidade"
                                    label="Unidade"
                                    show-default-option
                                    textField="nomeFantasia"
                                    v-model="form.unidadeId"
                                    valueField="id"
                                />
                            </rkm-col>

                            <rkm-col cols="6">
                                <rkm-form-select
                                    :disabled="isSaved || !form.unidadeId || hasItens"
                                    :options="infraestruturas"
                                    :validations="validations.infraestrutura"
                                    label="Local de atendimento"
                                    show-default-option
                                    textField="nome"
                                    v-model="form.infraestruturaId"
                                    valueField="id"
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col :cols="isSaved ? 4 : 6">
                                <rkm-form-select
                                    :disabled="isSaved || !form.infraestruturaId || hasItens"
                                    :options="centrosCusto"
                                    :validations="validations.centroCusto"
                                    label="Setor (Almoxarifado)"
                                    show-default-option
                                    textField="setorNome"
                                    v-model="model.centroCustoId"
                                    valueField="id"
                                />
                            </rkm-col>

                            <rkm-col cols="3">
                                <rkm-form-input
                                    label="Número"
                                    number
                                    v-model="model.numero"
                                    :disabled="isSaved || additionals.isNumeroRequisicaoAutomatico"
                                    :validations="validations.numero"
                                />
                            </rkm-col>

                            <rkm-col
                                v-if="isSaved"
                                cols="5"
                            >
                                <rkm-form-input
                                    disabled
                                    label="Usuário requisitante"
                                    v-model="form.usuarioRequisitanteNome"
                                />
                            </rkm-col>

                            <rkm-col
                                v-else
                                cols="3"
                            >
                                <rkm-form-select
                                    :disabled="hasItens"
                                    :options="form.modos"
                                    label="Modo"
                                    v-model="form.modoValue"
                                />
                            </rkm-col>
                        </rkm-row>
                    </rkm-form>
                </rkm-area>
            </rkm-form>

            <Material
                ref="Material"
                :data="{ additionals, form, model }"
                :disabled="!model.centroCustoId"
                :is-saved="isSaved"
                :is-modo-padrao="isModoPadrao"
            />
        </template>
    </div>
</template>

<script>
// Components.
import Material from './components/material/Index'

// Others.
import { mapActions } from 'vuex'
import { repository, error, object, stringCase } from '@/mixins'
import moment from 'moment'

export default {
    components: { Material },
    computed: {
        validations() {

            return {
                unidade: {
                    required: true,
                },
                infraestrutura: {
                    required: true,
                },
                centroCusto: {
                    required: true,
                },
                numero: {
                    required: true,
                    max: 20,
                },
            }
        },
        isSaved() {

            return !!this.id
        },
        isModoPadrao() {

            return this.form.modoValue === 'padrao'
        },
        infraestruturas() {

            if (this.form.unidadeId) {

                return this.form.unidades.find(u => u.id === this.form.unidadeId).infraestruturas
            }

            return []
        },
        centrosCusto() {

            if (this.form.infraestruturaId && this.infraestruturas.length > 0) {

                const infrasestrutura = this.infraestruturas.find(i => i.id === this.form.infraestruturaId)

                return infrasestrutura ? infrasestrutura.centrosCusto : []
            }

            return []
        },
        hasItens() {

            return this.isModoPadrao
                ? this.model.itens.length > 0
                : !!this.model.itens.find(i => !isNaN(parseInt(i.quantidade)))
        }
    },
    created() {

        this.repositories = {
            requisicao: this.getConectaSusRepository('almoxarifado.requisicaoAberturaFechamento')
        }

        this.load()
    },
    data: () => ({
        loaded: false,
        additionals: null,
        form: null,
        model: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            const request = this.id
                ? this.repositories.requisicao.edit(this.id)
                : this.repositories.requisicao.create()

            request
                .then(({ data }) => {

                    if (this.id) {

                        data.model.itens.filter(i => i.possuiEntradaComLote && Array.isArray(i.entradaItens))
                            .map(i => i.entradaItens
                                .filter(ei => ei.validadeLote != null)
                                .map(l => l.validadeLote = moment(l.validadeLote, 'DD/MM/YYYY').toDate())
                            )
                    }

                    this.additionals = data.additionals
                    this.form = data.form
                    this.model = data.model

                    this.addWatchers()
                    this.$emit('model-load', this.model)

                    this.loaded = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        addWatchers() {

            this.$watch('form.unidadeId', function () {

                this.form.infraestruturaId = null
            })

            this.$watch('form.infraestruturaId', function () {

                this.model.centroCustoId = null
            })

            this.$watch('infraestruturas', function (infraestruturas) {

                if (infraestruturas.length === 1) {

                    this.form.infraestruturaId = infraestruturas[0].id
                }
            })

            this.$watch('centrosCusto', function (centrosCusto) {

                if (centrosCusto.length === 1) {

                    this.model.centroCustoId = centrosCusto[0].id
                }
            })
        },
        save() {

            this.$refs.Form.validate().then(valid => {

                if (!valid) return

                this.$refs.Material.validate().then(valid => {

                    if (!valid) return

                    this.setLoading()

                    this.repositories.requisicao.store(this.prepareSaveData())
                        .then(() => {

                            this.showSaveNotification()
                            this.$emit('save')
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
            })
        },
        prepareSaveData() {

            const data = this.clone(this.model)
            let itens = []

            if (this.isModoPadrao) {

                itens = data.itens.map(item => ({
                    materialId: item.material.id,
                    quantidade: parseInt(item.quantidade, 10),
                }))
            }
            else {

                data.itens.forEach(i => i.materiais
                    .filter(m => !isNaN(parseInt(m.quantidade)))
                    .forEach(m => itens.push({
                        materialId: m.id,
                        quantidade: parseInt(m.quantidade, 10),
                    }))
                )
            }

            return this.camelObjectKeysToSnakeRecursive({
                centroCustoId: data.centroCustoId,
                numero: data.numero,
                itens
            })
        },
        saveRetorno(finalizar) {

            this.$refs.Material.validate().then(valid => {

                if (!valid) return

                this.showConfirmation(
                    `Ao ${finalizar ? 'finalizar' : 'salvar'}, as quantidades recebidas irão entrar no estoque.
                        Deseja continuar?.`,
                    async () => this.handleSaveRetorno()
                )
            })
        },
        handleSaveRetorno() {

            this.setLoading()

            this.repositories.requisicao.update(this.id, this.prepareSaveRetornoData())
                .then(({ data }) => {

                    this.showSaveNotification()

                    if (data.possuiNovoEnvio) {

                        this.$emit('partial-save')
                    }
                    else {

                        this.$emit('save')
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        prepareSaveRetornoData() {

            const data = this.clone(this.model)

            const itens = data.itens.map(item => {

                const itemData = {
                    respostaItemId: item.respostaItemId
                }

                if (item.possuiEntradaComLote) {

                    itemData.entradaItens = item.entradaItens.map(lote => ({
                        entradaItemId: lote.entradaItemId,
                        recebido: parseInt(lote.recebido),
                        lote: lote.lote,
                        validadeLote: lote.validadeLote != null
                            ? moment(lote.validadeLote).format('DD/MM/YYYY')
                            : null,
                        possuiLote: lote.possuiLote,
                    }))
                }
                else {

                    itemData.recebido = parseInt(item.recebido)
                }

                return itemData
            })

            return this.camelObjectKeysToSnakeRecursive({
                itens
            })
        },
    },
    props: {
        id: { type: Number },
    },
    mixins: [repository, error, object, stringCase]
}
</script>